export const ROUTES = {
  HOME: "/",
  TRACKING_TIME: "/tracking_time",
  TRACKING_TIME_RAW: "tracking_time",
  MANAGER: "/manager",
  LIST: "/list",
  DETAIL: "/detail",
  LATEST_TRIAL_BALANCE_FIRE: "latest-trial-balance-fire",
  APPS: "apps",
  APP_CATEGORIES: "app_categories",
  ADMIN: "admin",
  CONFIG: "config",
  SIGNIN: "login",
  PAYSLIP: "annual_salary_summaries",
  YEAR_SLUG: ":year",
  SALARY_CONFIG: "salary_config",
  ANNUAL_SALARY_LIST: "salary_list",
  ANNUAL_PAYMENT_LIST: "payment_list",
  MANUAL: "manual",
  PAYMENT_SHEETS: "payment_sheets",
  PAYSLIP_YEAR: "annual_salary_summaries/:year",
  ANNUAL_SALARY_SUMMARIES: "annual_salary_summaries",
  ANNUAL_PAYMENT_SUMMARIES: "annual_payment_summaries",
  ANNUAL_PAYMENT_SUMMARIES_YEAR: "annual_payment_summaries/:year",
  SALARY: "salary_sheets",
  PAYMENTS: "payment_sheets",
  STAFF_TAX_SHEETS: "staff_tax_sheets",
  SALARY_SHEETS: "salary_sheets",
  SALARY_LEDGERS: "salary_ledgers",
  SALARY_SHEET_FOR_WORKERS: "salary_sheet_for_workers",
  TRANSFERS: "transfers",
  DEDUCTIONS: "deductions",
  PROVISIONS: "provisions",
  NEW_PROVISIONS: "new-provisions",
  EXPENSES: "expenses",
  WORKS: "works",
  WORKS_DAY: "work_days",
  WORKS_TIME: "work_times",
  WORKERS: "workers",
  WORKERS_CREATE: "workers/create",
  WORKER_SHEETS: "worker_sheets",
  COMPANIES: "companies",
  ADMIN_CONFIG: "/admin/config",
  COMPANY_CONFIGURATION: "company_configuration",
  SALARY_CONFIGURATION: "salary_configuration",
  PROVISION_TYPE_CONFIG: "calculation",
  USERS: "users",
  AUTH: "auth",
  PERSONAL: "personal",
  USER_SHEETS: "user_sheets",
  CUSTOMER_SHEET: "customer_sheets",
  BRANCH: "branches",
  PERSONNEL: "organizational-chart",
  ORGANIZATION_CHART: "organizational-chart",
  FUNCTION: "function",
  ATTENDANCE: "attendance",
  PROJECT_MANAGE: "project_manage",
  CUSTOMER_LIST: "customers",
  PROJECT_LIST: "projects",
  PROJECT_LIST_SHEETS: "projects_list_sheets",
  ORGANIZATIONS: "organizations",
  ORGANIZATION_MANAGEMENT: "organization_management",
  MANAGEMENT: "management",
  DEPARTMENTS: "departments",
  DIVISIONS: "divisions",
  BRANCH_CHART: "branch_chart",
  ID: ":id",
  COMPANY_ID: ":companyId",
  APP_ID: ":appId",
  APP_TYPE: ":appType",
  CREATE: "create",
  EDIT: "edit",
  ARRANGEMENTS: "arrangements",
  TASKS: "tasks",
  ORGS: "orgs",
  TASKS_SHEETS: "tasks_sheets",
  POSITIONS: "positions",
  PERMISSION: "permission",
  APP_SUBMITTED_MANAGEMENT: "app_submitted_management",
  MAINTENANCE_NOTIFICATION: "maintenance_notification",
  SETTING_PRIVILEGE: "setting_privilege",
  PERMISSIONS_MANAGEMENT: "permissions_management",
  PERFORMANCE_APPRAISAL: "performance_appraisal",
  APPRAISAL_LIST: "performance_appraisal/appraisals",
  APPRAISAL_SETTING: "performance_appraisal/config",
  APPRAISAL_SHEET_LIST: "performance_appraisal/appraisal_sheets",
  APPRAISAL_ANALYST: "performance_appraisal/appraisal_analyst",
  APPRAISAL_KGI_LIST: "performance_appraisal/appraisal_kgi_list",
  APPRAISAL_SUMMARIES: "appraisal_summaries",
  NOT_FOUND_PAGE: "not_found",
  Electronic_Learning: "e-learning",
  COURSE_DETAIL: "course",
  STORE: "store",
  COURSES: "courses",
  COMPANY_DETAIL: "company_detail",
  SETTING_CATEGORIES: "setting-categories",
  PROJECT_MANAGER: "project-manager",
  PROJECT_MANAGER_LIST: "project-manager",
  PROJECT_MANAGER_DETAIL: "project-manager/:id",
  PROJECT_MANAGER_EDIT: "project-manager/:id/edit",
  PROJECT_MANAGER_TASK_VIEW: "project-manager/:id/tasks/:taskId",
  PROJECT_MANAGER_TASK_EDIT: "project-manager/:id/tasks/:taskId/edit",
  PROJECT_MANAGER_MEETING_CREATE: "project-manager/:id/meeting/create",
  PROJECT_MANAGER_MEETING_EDIT: "project-manager/:id/meeting/:meetingId/edit",
  PROJECT_MANAGER_MEETING_DETAIL: "project-manager/:id/meeting/:meetingId",
  PROJECT_MANAGER_MEETING_HISTORY:
    "project-manager/:id/meeting/:meetingId/history",
  PROJECT_MANAGER_MEETING_HISTORY_DETAIL:
    "project-manager/:id/meeting/:meetingId/history/:historyId",
  PROJECT_PHASE: "project-phase",
  PROJECT_PHASE_ID: ":phaseId",
  PROJECT_MANAGER_DETAIL_PHASE_LIST: "project-manager/:id/project-phase",
  PROJECT_PHASE_DETAIL: "project-manager/:id/project-phase/:phaseId",
  PROJECT_PHASE_EDIT: "project-manager/:id/project-phase/:phaseId/edit",
  KPI: "financial-report",
  KPI_PLANS: "financial-report/business-plans",
  KPI_DETAIL: "financial-report/business-plans/:businessPlanId",
  COMPANY_POLICIES: "company_policies",
  BUSINESS_MANUALS: "business_manuals",
  BUSINESS_TRIP_REPORTS: "business_trip_reports",
  EMPLOYMENT_CONTRACTS: "employment_contracts",
  AGREEMENTS: "agreements",
  CONTRACT_MANAGEMENT: "contract_management",
  CONTRACT_PAYMENT: "contract_management/contract_payment",
  CONTRACT_STAFF_LIST: "contract_management/staff_list",
  PAYMENT_HISTORY: "contract_management/payment_history",
  ANNUAL_ORG_SUMMARIES: "annual_org_summaries",
  FORBIDDEN: "forbidden",
  SHEET: "sheet",
  CUSTOMER_HISTORY_SUMMARIES: "customer_history_summaries",
  AGENT_SUMMARIES: "agent_summaries",
  BIZ_SHEET_SUMMARIES: "biz-sheet-summaries",
  BUSINESS_RPG: "business_rpg",
  BUSINESS_RPG_PLAY: "business_rpg/play",
  EVENT_FORMS: "biz-forms",
  EVENT_FORM_DETAIL: "biz-forms/manage/:formId",
  EVENT_FORM_PUBLIC: "biz-forms/apply/:publicKey",
  EVENT_FORM_STATUS: "biz-forms/status/:publicId",
  EVENT_FORM_VERIFICATION: "biz-forms/verify/:publicId",
  EVENT_FORM_POLICY: "biz-forms/policies/:policyKey",
  PASSWORD_RESET: "password_reset",
  LEGACY_EVENT_FORMS: "event-forms-admin",
  LEGACY_EVENT_FORM_DETAIL: "event-forms-admin/:formId",
  LEGACY_EVENT_FORM_PUBLIC: "event-forms/:publicKey",
  LEGACY_EVENT_FORM_STATUS: "event-form-status/:publicId",
  LEGACY_EVENT_FORM_POLICY: "event-form-policies/:policyKey",
  PERMISSION_SUMMARIES: "permission_summaries",
  CALENDAR: "calendar",
  CORRELATION_DIAGRAM: "correlation_diagram",
  PROJECT_CHART: "project-chart",
  WORKER_INVITE_CHART: "worker_invite_chart",
  ELECTRONIC_LEARNING_CHART: "e-learning-chart",
  COMPANY_POLICIES_CHART: "company-policies-chart",
  BUSINESS_CONTROLS_CHART: "business-controls-chart",
  SETTING_STATUSES: "setting-statuses",
  LIST_MESS: "list_mess",
  ROLE_PERMISSIONS: "role_permissions",
  LABOR_DOCUMENTS: "labor_documents",
  FINANCIAL_REPORTS: "financial_reports",
  BUSINESS_FLOW: "business_flow",
  FIRE_RPG_FAMILY_EVENT_SETTING: "fire_rpg/family_events_settings",
  FIRE_RPG_MICRO_EVENT_SETTING: "fire_rpg/micro_events_settings",
  FIRE_RPG_MACRO_EVENT_SETTING: "fire_rpg/macro_events_settings",
  FIRE_RPG_MARKET_CHART: "fire_rpg/market_chart",
  FIRE_RPG_MARKET_TABLE: "fire_rpg/market_table",
  FIRE_RPG_JOB_CONFIGS: "fire_rpg/job_configs",
  FIRE_RPG_GAME_SETTING: "fire_rpg/game_settings",
  FIRE_RPG_MARKET_ECONOMY_VIEW: "fire_rpg/market_economy_view",
};

export const PERMISSIONS_TABS = {
  APP_PERMISSIONS: "app_permissions",
  WORKER_PERMISSIONS: "worker_permissions",
};
